import classNames from "classnames"

import { ICONS } from "@doktor-se/bones-ui"

import styles from "./UserOnlineStatus.module.scss"

interface UserOnlineStatusProps {
  online: boolean
}

const UserOnlineStatus = ({ online }: UserOnlineStatusProps): JSX.Element => {
  return (
    <div
      className={classNames(styles.dot, {
        [styles.online]: online,
        [styles.offline]: !online
      })}>
      {online && <ICONS.Check color={"var(--oncolor-onsuccess-50)"} width={"14px"} height={"14px"} />}
      {!online && <ICONS.Close color={"var(--oncolor-onsuccess-50)"} width={"8px"} height={"8px"} />}
    </div>
  )
}

export default UserOnlineStatus
